
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-ruby-1-getting-started.json") })
        }
      }, "path---graphql-ruby-1-getting-started");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-ruby-1-getting-started!./.cache/json/graphql-ruby-1-getting-started.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-ruby-1-getting-started!./.cache/json/graphql-ruby-1-getting-started.json
// module chunks = 154